import { Link } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container, Img } from "@/components/common/Primitives";
import { useLang } from "@/lib/i18n";
import { usePageMeta } from "@/lib/seo";
import { SIZES } from "@/lib/images";

export default function NotFound() {
  const { tx } = useLang();
  usePageMeta("404");
  const links = [
    ["/rom", tx("Rom og prisar", "Rooms and rates")],
    ["/mat", tx("Mat og menyar", "Food and menus")],
    ["/opplev", tx("Opplev Skånevik", "Explore Skånevik")],
    ["/praktisk", tx("Praktisk informasjon", "Practical information")],
    ["/mi-bestilling", tx("Mi bestilling", "My booking")],
  ];
  return (
    <Container className="py-16 lg:py-24" data-testid="not-found-page">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center lg:gap-16">
        <div className="lg:col-span-7">
          <p className="text-sm font-medium text-muted-foreground tabular">404</p>
          <h1 className="mt-3 max-w-[16ch] text-[2.5rem] font-semibold leading-[0.98] tracking-[-0.035em] text-foreground sm:text-[3.25rem]">{tx("Denne sida finst ikkje.", "This page does not exist.")}</h1>
          <p className="mt-4 max-w-md text-lg text-muted-foreground">{tx("Lenkja kan vere gamal, eller adressa er skriven feil. Her er dei vanlegaste vegane vidare.", "The link may be old, or the address was mistyped. Here are the most common ways onward.")}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button asChild size="lg" data-testid="not-found-home"><Link to="/">{tx("Til framsida", "Front page")}</Link></Button>
            <Button asChild size="lg" variant="soft" data-testid="not-found-book"><Link to="/bestill"><Search className="h-4 w-4" /> {tx("Sjå ledige rom", "See available rooms")} <ArrowRight className="h-4 w-4" /></Link></Button>
          </div>
          <ul className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-[0.9375rem]" data-testid="not-found-links">
            {links.map(([to, label]) => (
              <li key={to}><Link to={to} className="font-medium text-foreground underline decoration-border underline-offset-[6px] transition-colors hover:decoration-foreground">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5">
          <Img src="/images/rainbow-fjord.jpg" alt={tx("Regnboge over Skånevikfjorden", "Rainbow over the Skånevik fjord")} className="aspect-square max-w-md" radius="rounded-[24px]" sizes={SIZES.half} />
        </div>
      </div>
    </Container>
  );
}
